import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { BackHandler, Keyboard, View } from "react-native"
import { VideoPoint } from "./VideoPoint"
import { baseColors } from "@Constants/baseStyles"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { ActivityIndicator } from "react-native-paper"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { useRecoilState, useRecoilValue } from "recoil"
import { canGotoNextAtom, surveyIsFinishedAtom, surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import { userAtom } from "@Recoil/Atom/userAtom"
import { EventName } from "@Constants/constant"
import { currentDiagnosisAtom, diagnosisShouldUpdateAtom, diagnosisStatusAtom } from "@Recoil/Atom/DiagnosisAtom"
import styles from "./styles"
import { SurveyHeader } from "./SurveyHeader"
import { getQuestionWidget, gotoSurvery } from "./Surveylogic"
import { useSurveyHandler } from "./Logic"
import { useFetchAllAxis } from "../../Hooks"
import { DiagnosticEducatifContext } from "@Providers/DiagnosticEducatifProvider"
import { useFocusEffect } from "@react-navigation/native"
import Constants from "expo-constants"
import { SurveyContext } from "@Providers/SurveyProvider"
import { useUserPrograms } from "../../Hooks/useUserPrograms"
import { UserProgramContext } from "@Providers/ProgramProvider"
import { isCptsInstance } from "@Utils/utils"
const { salutance } = Constants.expoConfig.extra

export const SurveyPage = ({ navigation, route }) => {
    const isSurveyFinished = useRecoilValue(surveyIsFinishedAtom)
    const axisId = route?.params?.axisId
    const bgColor = route?.params?.bgColor
    const allAxis = route?.params?.allAxis
    const forVideoPoint = route?.params?.forVideoPoint
    const { axisLastItemIndex } = useContext(DiagnosticEducatifContext)
    const { indexToSkip, setIndexToSkip } = useContext(SurveyContext)
    const { preselectedPatientProgram } = useContext(UserProgramContext)
    const axeIndex = route?.params?.axeIndex
    const fromPrev = route?.params?.fromPrev
    const surveysResponses = useRecoilValue(surveyResponsesAtom)
    const user = useRecoilValue(userAtom)
    const { fetchAllAxisSurveyResponsesById, fetchingResponseByAxeId, responseByAxeId } = useFetchAllAxis({ user })
    const diagnosisStatusList = useRecoilValue(diagnosisStatusAtom)
    const [loading, setLoading] = useState(true)
    const [surveysList, setSurveysList] = useState([])
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
    const [surveyParentId, setSurveyParentId] = useState(0)
    const indexOfCurrentAxis = []?.map((itm) => itm.id).indexOf(axisId)
    const [currentAxisIndex, setCurrentAxisId] = useState(indexOfCurrentAxis !== -1 ? indexOfCurrentAxis : 0)
    const [appointement, setAppointment] = useState(null)
    const [calendarId, setCalendarId] = useState(0)
    const [saving, setSaving] = useState(false)
    const canGotoNext = useRecoilValue(canGotoNextAtom)
    const [isKeyboardVisible, setKeyboardVisible] = useState(false)
    const [diagnosisShouldUpdate, setDiagnosisShouldUpdate] = useRecoilState(diagnosisShouldUpdateAtom)
    const [currentEducationalDiagnosis, setCurrentEducationalDiagnosis] = useRecoilState(currentDiagnosisAtom)
    const educationalDEId = currentEducationalDiagnosis?.id ?? 0
    const disableNextBtn = currentEducationalDiagnosis?.id > 0
    const [progressMessage, setProgressMessage] = useState("Création d'un nouveau diagnostic éducatif")
    const canProgramRDV = !(
        currentQuestionIndex == surveysList.length - 1 &&
        currentAxisIndex == allAxis.length - 1 &&
        !isSurveyFinished
    )

    const { fetchUserPrograms, currentUserProgram } = useUserPrograms()

    useEffect(() => {
        fetchUserPrograms()
    }, [])

    const [globalPayload, setGlobalPayload] = useState("xxxx")

    useEffect(() => {
        setGlobalPayload(surveysResponses)
    }, [surveysResponses])

    useEffect(() => {
        if (preselectedPatientProgram?.length > 0 && preselectedPatientProgram?.[0]?.surveyParentId > 0) {
            setSurveyParentId(preselectedPatientProgram?.[0]?.surveyParentId)
        }
    }, [preselectedPatientProgram])

    const navigateToRdvVideo = () =>
        gotoSurvery({
            axis: { name: "Rendez-vous", id: allAxis[allAxis?.length - 1].id },
            bgColor: baseColors.black,
            forVideoPoint: true
        })

    const { fetchSurveys, handleNextBtn, handlePrevBtn, handleFetchCalendar, performCreateEvent } = useSurveyHandler({
        fromPrev: fromPrev,
        surveysResponses: globalPayload,
        user,
        appointement,
        navigation,
        diagnosisShouldUpdate,
        diagnosisStatusList,
        surveysList,
        axisId,
        allAxis,
        forVideoPoint,
        currentAxisIndex,
        currentQuestionIndex: +currentQuestionIndex ?? 0,
        calendarId,
        bgColor,
        axeIndex,
        axisLastItemIndex,
        educationalDEId,
        indexToSkip,
        currentUserProgram,
        surveyParentId,
        setIndexToSkip,
        setSaving,
        setProgressMessage,
        setDiagnosisShouldUpdate,
        setSurveysList,
        setLoading,
        setCurrentQuestionIndex,
        navigateToRdvVideo,
        setCurrentAxisId,
        setCalendarId,
        setCurrentEducationalDiagnosis
    })

    useEffect(() => {
        const keyboardDidShowListener = Keyboard.addListener("keyboardDidShow", () => {
            setKeyboardVisible(true)
        })
        const keyboardDidHideListener = Keyboard.addListener("keyboardDidHide", () => {
            setKeyboardVisible(false)
        })

        return () => {
            keyboardDidHideListener.remove()
            keyboardDidShowListener.remove()
        }
    }, [])

    useEffect(() => {
        forVideoPoint && setCurrentAxisId(5)
        handleFetchCalendar()
    }, [])

    useEffect(() => {
        LocalStorage.saveLastAxeSurvey(axeIndex)
    }, [axeIndex])

    useEffect(() => {
        if (salutance) {
            if (
                (currentEducationalDiagnosis === null && currentQuestionIndex > 0) ||
                (currentEducationalDiagnosis?.id > 0 && currentQuestionIndex)
            ) {
                LocalStorage.saveLastAxeSurveyIndex(currentQuestionIndex)
            }
        } else {
            LocalStorage.saveLastAxeSurveyIndex(currentQuestionIndex)
        }
    }, [currentQuestionIndex, salutance, currentEducationalDiagnosis])

    useEffect(() => {
        if (axisId > 0) {
            if (!isCptsInstance()) {
                fetchAllAxisSurveyResponsesById(axisId)
                fetchSurveys()
            } else {
                if (surveyParentId > 0) {
                    fetchAllAxisSurveyResponsesById(axisId)
                    fetchSurveys()
                }
            }
        }
    }, [axisId, surveyParentId])

    useFocusEffect(
        useCallback(() => {
            const onBackPress = () => {
                if (+currentQuestionIndex === 0) {
                    navigation.goBack()
                } else {
                    setCurrentQuestionIndex(+currentQuestionIndex - 1)
                }
                return true
            }

            BackHandler.addEventListener("hardwareBackPress", onBackPress)

            return () => BackHandler.removeEventListener("hardwareBackPress", onBackPress)
        }, [currentQuestionIndex])
    )

    const hasDEInProgress = currentEducationalDiagnosis !== null

    const btnLabel = `${
        currentQuestionIndex == surveysList?.length - 1
            ? axeIndex === axisLastItemIndex
                ? hasDEInProgress
                    ? "Terminer"
                    : "Envoyer"
                : "Axe suivant"
            : forVideoPoint
            ? "Terminer"
            : "Suivant"
    }`
    const hasScheduledVisio = currentEducationalDiagnosis?.visioconference?.id > 0

    const disableNext =
        !hasDEInProgress &&
        ((forVideoPoint && !appointement) || saving || (disableNextBtn && !forVideoPoint) || !canGotoNext)

    const hideLastBtn =
        axeIndex === axisLastItemIndex && currentQuestionIndex == surveysList.length - 1 && hasDEInProgress
    const isParent = surveysList[currentQuestionIndex]?.hasChild === 1
    const hideStepper = surveysList?.length > 20

    return (
        <ContainerStackScreen style={{ paddingHorizontal: 0, paddingTop: 0, backgroundColor: baseColors.white }}>
            {!isKeyboardVisible && (
                <SurveyHeader
                    loading={loading}
                    currentAxisIndex={currentAxisIndex}
                    currentQuestionIndex={currentQuestionIndex}
                    surveysList={surveysList}
                    axisName={route?.params?.axisName}
                    bgColor={route?.params?.bgColor}
                    allAxis={route?.params?.allAxis}
                    forVideoPoint={route?.params?.forVideoPoint}
                />
            )}

            <CustomScrollview contentContainerStyle={{ flexGrow: 1 }} paddingBottom={50} paddingTop={0}>
                {loading || fetchingResponseByAxeId ? (
                    <ActivityIndicator style={{ margin: 20 }} color={baseColors.green.primary} size={"small"} />
                ) : (
                    <View>
                        <View style={styles.overlay}>
                            {!forVideoPoint && !hideStepper && (
                                <View style={styles.dotsContainer}>
                                    {surveysList?.map((item, i) => (
                                        <View
                                            key={i}
                                            style={{
                                                ...styles.dot,
                                                backgroundColor:
                                                    i <= currentQuestionIndex ? baseColors.green.dark : baseColors.grey
                                            }}
                                        />
                                    ))}
                                </View>
                            )}
                            {forVideoPoint ? (
                                <VideoPoint
                                    eventType={EventName.DIAGNOSTIC_EDUCATIF}
                                    handleChange={(apntment) => setAppointment(apntment)}
                                />
                            ) : (
                                currentQuestionIndex < surveysList.length &&
                                getQuestionWidget({
                                    question: surveysList[currentQuestionIndex],
                                    isChildren: false,
                                    axisId,
                                    currentQuestionIndex,
                                    fetchingResponseByAxeId,
                                    responseByAxeId,
                                    hasDEInProgress,
                                    isParent
                                })
                            )}

                            <View style={{ ...styles.col, justifyContent: forVideoPoint ? "center" : "space-between" }}>
                                {!hasScheduledVisio && !forVideoPoint && (
                                    <Button
                                        text="Précédent"
                                        width="40%"
                                        disabled={(currentAxisIndex == 0 && currentQuestionIndex == 0) || saving}
                                        onPress={handlePrevBtn}
                                        backgroundColor={baseColors.green.light}
                                        labelColor={baseColors.green.dark}
                                    />
                                )}

                                {!hasScheduledVisio && !forVideoPoint && (
                                    <Button
                                        text={btnLabel}
                                        width="40%"
                                        disabled={!isParent && (disableNext || hideLastBtn)}
                                        onPress={!forVideoPoint ? handleNextBtn : performCreateEvent}
                                        backgroundColor={baseColors.green.primary}
                                        labelColor={"white"}
                                        loading={saving}
                                    />
                                )}
                            </View>
                        </View>

                        {!hideLastBtn && !canProgramRDV && (
                            <OpenSansText
                                color={baseColors.orange.primary}
                                style={{ textAlign: "center", marginTop: 30, padding: 12 }}
                                fontSize={14}
                            >
                                Veuillez completer toute les questionnaire pour pouvoir programmer un rendez-vous
                            </OpenSansText>
                        )}

                        {saving && progressMessage && canProgramRDV && (
                            <OpenSansText style={{ marginTop: 20 }} fontSize={14} textAlign={"center"}>
                                {progressMessage + " ..."}
                            </OpenSansText>
                        )}
                    </View>
                )}
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
